<template>
    <div class="common-module-page">
        <div class="page">
            <CommonTitle title="成果展示" :showMore="showMore" @goMore="openMoreDialog" />
            <div class="live-list" v-if="list.length">
                <live-item class="live-item" v-for="item in list" :key="item.id" :data="item" />
            </div>
            <no-data v-else :width="120" :height="80" url="no-data@2x.png" info="暂无内容" />
        </div>
        <school-list-dialog ref="SchoolListDialogRef" />
    </div>
</template>

<script setup>
import { ref } from 'vue';
import CommonTitle from '@/components/home-common-title/common-more.vue';
import NoData from '@/components/no-data.vue';
import SchoolListDialog from './list-dialog.vue';
import LiveItem from './live-item.vue';

const list = ref([]);
const showMore = ref(false);
const SchoolListDialogRef = ref();

fetchList();

function fetchList() {
    const pageSize = 4;
    G_transmit('homeLivingList', {
        name: 'homeLivingList',
        queries: {
            page_num: 1,
            page_size: pageSize,
        },
    })
        .then(({ data }) => {
            const ids = (data?.rows || []).map(item => item.meeting_code);
            showMore.value = (data?.total_count || 0) > pageSize;
            fetchListDetail(ids);
        })
        .catch(err => {
            G_dispatchEvent('toast', { message: err.status.desc, type: 'error' });
        });
}

function fetchListDetail(ids) {
    if (ids.length === 0) return;
    G_transmit('listLivesByIds', {
        name: 'listLivesByIds',
        data: {
            ids,
        },
    })
        .then(({ data }) => {
            list.value = data || [];
        })
        .catch(err => {
            G_dispatchEvent('toast', { message: err.status.desc, type: 'error' });
        });
}

function openMoreDialog() {
    SchoolListDialogRef.value.openDialog();
}
</script>

<style lang="scss" scoped>
.common-module-page {
    padding-bottom: 40px;
    background: #fff;
    .page {
        width: 1200px;
        margin: 0 auto;
    }
}
.school-list {
    margin-left: -20px;
    li {
        width: 386px;
        height: 126px;
        display: inline-block;
        margin: 20px 0 0 20px;
        padding: 0 7px;
        background: url('~@/assets/img/home/school-bg.png') no-repeat 0 0;
        background-size: 100% auto;
        text-align: center;
        .school-item {
            width: 120px;
            display: inline-block;
            vertical-align: top;
            margin: 0 33px;
        }
        .school-badge {
            width: 46px;
            height: 46px;
            border-radius: 50%;
            margin-top: 26px;
        }
        .school-name {
            margin-top: 10px;
            font-family: MicrosoftYaHei;
            font-weight: bold;
            font-size: 12px;
            color: #222222;
            line-height: 18px;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
        }
        &:hover {
            box-shadow: 0px 1px 12px 0px rgba(0, 0, 0, 0.15);
        }
    }
}
.live-list {
    margin-top: 20px;
    margin-right: -20px;
    .live-item {
        display: inline-block;
        width: 285px;
        margin: 0 20px 20px 0;
    }
}
</style>
